export default {
  name: 'Gallery section - 6',
  tab: 'gallery',
  type: 'slideshow-default-section',
  content: {
    title: 'Slideshow section',
    introtext: '',
    slides:
      '[{"slide-title":"Slide 1","slide-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","slide-image":"/storage/media/samples/duy-pham-6iYs78oCiZA-unsplash.jpg","button-text":"Read more","button-link":"#","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"},{"slide-title":"Slide 2","slide-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","slide-image":"/storage/media/samples/erol-ahmed-_MYcIi9DgYQ-unsplash.jpg","button-text":"Read more","button-link":"#","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"},{"slide-title":"Slide 3","slide-introtext":"<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>","slide-image":"/storage/media/samples/jeremy-thomas-Qw2CUd_9OWo-unsplash.jpg","button-text":"Read more","button-link":"#","button-style":"default","button-background-color":"var(--secondary-color)","button-text-color":"var(--text-light-color)"}]'
  },
  design: {
    'title-color': 'var(--text-light-color)',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h4',
    'introtext-color': 'var(--text-light-color)'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'xl',
    'content-horizontal-alignment': 'start',
    'content-box': '0',
    'content-box-color': 'black',
    'content-box-padding': '30px',
    'content-box-opacity': '0.5',
    'content-box-elevation': '0',
    'content-box-rounded': '0'
  },
  advanced: {}
}
